import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _HorizontalPilotCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M6 6.661h2.44v4.881L13.018 21h5.492" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M18.492 18.56h-3.966l-3.644-7.018V6.661h2.44M8.746 14.898 6.61 19.17M8.5 4.83h1.22m1.22 0H9.72m0 0V3" })] }) });
}
const HorizontalPilotCustom = forwardRef(_HorizontalPilotCustom);
export { HorizontalPilotCustom };
